<section>
    <label *ngIf="options.header" [ngClass]="{ 'accessibility-hidden': options.headerInvisible }" [for]="options.inputId">{{ options.header }}
        <span class="required-indicator" *ngIf="formCtrl.hasValidator(validators.required)" aria-hidden="true">*</span>
    </label>
    <ng-content></ng-content>
    <div *ngIf="errorToShow && formCtrl.dirty && formCtrl.touched">
        <span class="error" id="aria-{{ options.inputId }}" role="alert" aria-live="polite">{{ errorToShow }}</span>
    </div>
    <p class="subheader" *ngIf="options.subHeader" [ngClass]="{ 'accessibility-hidden': options.headerInvisible }" [attr.id]="'desc-' + options.inputId">{{ options.subHeader }}</p>
</section>
